export default __webpack_public_path__ + "static/media/RetroStereoWide.47109105.ttf";